<template>
        <button
            title="Toggle Theme"
            @click="toggleColorMode"
            class="color-mode-picker p-0"
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
            >
                <path
                    pathLength="1"
                    class="moon-icon"
                    d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"
                />
                <circle class="sun-icon" cx="12" cy="12" r="5" />
                <line class="sun-icon" x1="12" y1="1" x2="12" y2="3" />
                <line class="sun-icon" x1="12" y1="21" x2="12" y2="23" />
                <line class="sun-icon" x1="4.22" y1="4.22" x2="5.64" y2="5.64" />
                <line class="sun-icon" x1="18.36" y1="18.36" x2="19.78" y2="19.78" />
                <line class="sun-icon" x1="1" y1="12" x2="3" y2="12" />
                <line class="sun-icon" x1="21" y1="12" x2="23" y2="12" />
                <line class="sun-icon" x1="4.22" y1="19.78" x2="5.64" y2="18.36" />
                <line class="sun-icon" x1="18.36" y1="5.64" x2="19.78" y2="4.22" />
            </svg>
        </button>
</template>

<script setup>
const colorMode = useColorMode()

const toggleColorMode = () => colorMode.preference = colorMode.preference === 'dark' ? 'light' : 'dark';


if (colorMode.preference === 'system') {
    colorMode.preference = colorMode.value
}
</script>

<style scoped>
:root {
    --transition-duration: 400ms;
    transition: color var(--transition-duration),
    background-color var(--transition-duration);
}

svg {
    transition: stroke var(--transition-duration);
}

.moon-icon {
    stroke-dasharray: 0px 1px;
    opacity: 0;
    transition: stroke-dasharray 0.5s ease-in,
    opacity 300ms ease-in;
}

.sun-icon {
    stroke-dasharray: 1px 1px;
    opacity: 1;
    transition: stroke-dasharray 0.5s ease-in,
    opacity 300ms ease-in;
}

.dark-mode .moon-icon {
    stroke-dasharray: 1px 1px;
    opacity: 1;
}

.dark-mode .sun-icon {
    stroke-dasharray: 0px 1px;
    opacity: 0;
}

.light-mode .moon-icon {
    stroke-dasharray: 0px 1px;
    opacity: 0;
}

.light-mode .sun-icon {
    stroke-dasharray: 1px 1px;
    opacity: 1;
}
</style>
